import React from 'react';
import classNames from 'classnames';
import Guide from './Guide';
import styles from './guides.module.scss';
import projectManagement from './img/project-management@2x.png';
import projectPlanning from './img/project-planning@2x.png';
import artAndScience from './img/art-and-science@2x.png';

const Guides = () => (
  <div>
    <h2 className={classNames('is-size-3', styles.Guides__heading)}>Guides</h2>
    <div className="columns">
      <div className="column is-6">
        <Guide
          heading="The Art & Science of Leading Projects"
          href="https://www.teamgantt.com/art-science-of-leading-projects"
          imgSrc={artAndScience}
          text="A free video course teaching you how to lead projects and manage teams"
        />
      </div>
      <div className="column is-6">
        <Guide
          heading="The Guide to Project Management"
          href="https://www.teamgantt.com/guide-to-project-management/"
          imgSrc={projectManagement}
          text="A how-to guide for project managers written by Brett Harned"
        />
      </div>
    </div>
    <div className="columns">
      <div className="column is-6">
        <Guide
          heading="The Guide to Project Planning"
          href="https://www.teamgantt.com/guide-to-project-planning"
          imgSrc={projectPlanning}
          text="A downloadable guide to help you create project plans and keep projects on track"
        />
      </div>
    </div>
  </div>
);

export default Guides;



// WEBPACK FOOTER //
// ./src/components/guides/index.js